/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiProgressStep,
    ApiProgressStepFromJSON,
    ApiProgressStepFromJSONTyped,
    ApiProgressStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiProgressStepsList
 */
export interface ApiProgressStepsList {
    /**
     * 
     * @type {Array<ApiProgressStep>}
     * @memberof ApiProgressStepsList
     */
    progressStepList?: Array<ApiProgressStep>;
}

export function ApiProgressStepsListFromJSON(json: any): ApiProgressStepsList {
    return ApiProgressStepsListFromJSONTyped(json, false);
}

export function ApiProgressStepsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiProgressStepsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'progressStepList': !exists(json, 'progressStepList') ? undefined : ((json['progressStepList'] as Array<any>).map(ApiProgressStepFromJSON)),
    };
}

export function ApiProgressStepsListToJSON(value?: ApiProgressStepsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'progressStepList': value.progressStepList === undefined ? undefined : ((value.progressStepList as Array<any>).map(ApiProgressStepToJSON)),
    };
}

